import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base';

@Injectable({
  providedIn: 'root',
})
export class EmailService extends BaseService {
  protected constructor() {
    super('Email');
  }

  emailReport(to: string, pdfOutput: string): Observable<any> {
    return this.httpService.postForText(`${this.apiUrl}/EmailReport/${encodeURIComponent(to)}`, pdfOutput);
  }

  /**
   * Sends a report email. Everything travels in the POST body alongside the PDF —
   * the old EmailReportWithSellingCompany route carried it all in the URL path with the
   * body base64-encoded, which capped the message at the request-line length limit the
   * moment the body could be formatted HTML. The route stays in the API for one release;
   * nothing here calls it any more.
   *
   * `emailBody` follows the narrative storage contract (marked rich text or legacy plain);
   * the API sanitises it against the email allowlist before anything is sent.
   */
  sendReport(
    model: {
      email: string;
      ccEmail?: string;
      bccEmail?: string;
      subject: string;
      emailBody?: string;
      attachDocuments?: boolean;
      type?: string;
      key?: string;
      sellingCompany?: string;
      // The Document being sent and the record it is for, so the API can add the files
      // configured on that document's Attachments tab. Both optional: without them the send
      // behaves exactly as it did before configured attachments existed.
      documentType?: string;
      reportId?: string;
    },
    // FormData already carrying the report PDF under the 'pdf' key.
    pdfOutput: FormData,
  ): Observable<any> {
    pdfOutput.append('email', model.email);
    pdfOutput.append('ccEmail', model.ccEmail ?? '');
    pdfOutput.append('bccEmail', model.bccEmail ?? '');
    pdfOutput.append('subject', model.subject);
    pdfOutput.append('emailBody', model.emailBody ?? '');
    pdfOutput.append('attachDocuments', String(model.attachDocuments ?? false));
    pdfOutput.append('type', model.type ?? '');
    pdfOutput.append('key', model.key ?? '');
    pdfOutput.append('sellingCompany', model.sellingCompany ?? '');
    if (model.documentType) {
      pdfOutput.append('documentKey', model.documentType);
    }
    if (model.reportId) {
      pdfOutput.append('reportId', model.reportId);
    }

    return this.httpService.postForText(`${this.apiUrl}/SendReport`, pdfOutput);
  }
}
